import React from 'react';
import BackButton from 'components/backButton';
import { Icon } from 'components/ui/icon';

const NoDetails = () => {
  return (
    <div className="flex flex-col justify-center items-center gap-2 h-screen">
      <h5 className="flex flex-col justify-center items-center gap-2">
        <Icon
          name="alert-circle"
          size={36}
          className="text-red-500 mb-2"
          aria-hidden="true"
        />
        No details available
      </h5>
      <BackButton content={'Return'} />
    </div>
  );
};

export default NoDetails;
